import React, { useContext, useState } from "react";
import venomContext from "../../context/venomContext";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import classNames from "classnames";

export default function Categories() {
  const context = useContext(venomContext);
  const { createCategory, allCategories, categories, deleteCategory } = context;
  const { all_cat } = categories;
  const [catName, setCatName] = useState({ cat_name: "" });
  const theme_color = localStorage.getItem("theme");
  //   const ModelFormHandler = (e) => {
  //     e.target.click();
  //   };
  const ModelOnChange = (e) => {
    setCatName({ [e.target.name]: e.target.value });
  };
  const createCatHandler = async () => {
    const { cat_name } = catName;
    if (!cat_name || cat_name.length < 3) {
      toast.warn("All Fields are required", {
        position: "bottom-right",
      });
      return;
    }
    createCategory(cat_name);
    setCatName({ cat_name: "" });
    await allCategories();
  };
  return (
    <>
      <div className="blogs-all d-flex justify-content-between align-items-center mt-4">
        <h3
          className={classNames("m-0", {
            "text-light": localStorage.getItem("mode") === "dark",
          })}
        >
          All Categories
        </h3>
        <div className="right-content">
          <i
            className="fas fa-sync me-3"
            style={{ cursor: "pointer" }}
            onClick={async (e) => {
              e.target.classList.add("active");
              await allCategories();
              e.target.classList.remove("active");
              toast.success("Categories updated", {
                position: "bottom-right",
              });
            }}
          ></i>
          <button
            className={"btn btn-md btn-" + theme_color}
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            Create Category
          </button>
        </div>
      </div>
      <div className="tabular-data">
        <table className="table table-bordered align-middle table-striped table-hover mt-3">
          <thead>
            <tr>
              <th style={{ width: "10%" }}>#</th>
              <th scope="col">Category</th>
              <th scope="col">Total Blogs</th>
              <th style={{ width: "25%" }}>Updated at</th>
              <th style={{ width: "10%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {all_cat && all_cat.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center">
                  <h6 className="m-0">No Categories Found</h6>
                </td>
              </tr>
            )}
            {!all_cat ? (
              <Loader />
            ) : (
              all_cat.map((curElem, index) => {
                const { _id, cat_name, total_blogs, updatedAt } = curElem;
                var date = new Date(updatedAt);
                let splitedDate = date.toString().split(" ");
                let month = splitedDate[1];
                let day = splitedDate[2];
                let year = splitedDate[3];
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? "pm" : "am";
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                hours = hours < 10 ? "0" + hours : hours;
                minutes = minutes < 10 ? "0" + minutes : minutes;
                var dateTime =
                  month +
                  ", " +
                  day +
                  " " +
                  year +
                  " at " +
                  hours +
                  ":" +
                  minutes +
                  " " +
                  ampm;
                return (
                  <tr key={_id}>
                    <th scope="row">{index + 1}</th>
                    <td>{cat_name}</td>
                    <td>{total_blogs}</td>
                    <td>{dateTime}</td>
                    <td colSpan="2">
                      <i
                        className="fas fa-trash-alt"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.target.classList.remove("fa-trash-alt");
                          e.target.classList.add("fa-sync", "active");
                          deleteCategory(_id);
                          setTimeout(async () => {
                            await allCategories();
                            e.target.classList.add("fa-trash-alt");
                            e.target.classList.remove("fa-sync", "active");
                          }, 3000);
                        }}
                      ></i>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create Category
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="blog-form">
                <div className="form-group">
                  <label htmlFor="cat_name">Category Name</label>
                  <input
                    type="text"
                    value={catName.cat_name}
                    name="cat_name"
                    onChange={ModelOnChange}
                    className={"form-control my-2 input-" + theme_color}
                    id="cat_name"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                // ref={refClose}
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                onClick={() => {
                  createCatHandler();
                  setTimeout(async () => {
                    await allCategories();
                  }, 1500);
                }}
                type="button"
                className={"btn btn-" + theme_color}
                disabled={!catName.cat_name || catName.cat_name.length < 3}
                data-bs-dismiss="modal"
              >
                <i className="fal fa-spinner-third me-2 loading d-none"></i>
                Create Category
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
